import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import StyleSheet from './AddButton.module.scss';

interface AddButtonProps {
    color?: string;
    className?: string;
    onClick: () => void;
}

export const AddButton: FunctionComponent<AddButtonProps> = props => {
    return (
        <div
            className={clsx(StyleSheet.container, props.className)}
            style={{ borderColor: props.color }}
            onClick={props.onClick}
        >
            <FontAwesomeIcon
                icon={faPlus}
                fontSize={18}
                color={props.color ?? '#92B4A7'}
            />
        </div>
    );
};

export default AddButton;
